import { Dialog } from "./Dialog";
import { CopyTextControl } from "components/controls";
import { getGifEmbedCode } from "utils/share";

import "./EmbedGifDialog.scss";

export const EmbedGifDialog = (props: {
  id: string;
  onClose: () => void;
}): JSX.Element => {
  const fixedCode = getGifEmbedCode(props.id);

  return (
    <Dialog
      onClose={props.onClose}
      title="Embed gif"
      className="embedGifDialog"
    >
      <>
        <div className="group">
          <label>Fixed frame:</label>
          <CopyTextControl value={fixedCode}/>
        </div>

        <div className="group">
          <label>Responsive frame:</label>
          <CopyTextControl value={fixedCode}/>
        </div>
      </>
    </Dialog>
  );
};
